<template>
  <base-page :showBgImg="false">
    <template #full>

    <div class="setting-cnt">
      <div class="menus">
        <router-link v-for="(menu, idx) in menus" :key="'menu_' + idx" :to="menu.path">
          <div class="menu" :style="{
            borderRadius: idx === 0 ?  '13px 13px 0px 0px' : (idx === menus.length - 1 ? '0px 0px 13px 13px' : '0px'),
          }" :class="menu.path === currentPath ? 'menu-selected' : ''" >
            <img v-if="menu.icon" :src="menu.icon" class="icon"/>
            <span class="name">{{ menu.name }}</span>
          </div>
        </router-link>


      </div>
      <div class="setting-body">
        <router-view/>
      </div>
    </div>
    </template>
  </base-page>
</template>

<script>
import BasePage from "@/components/base-page/index.vue";

export default {
  name: "index",
  components: {
    BasePage
  },
  watch:{
    $route: {
      handler(to, from){
        console.log(to.path, from);
        this.currentPath = to.path
      },
      immediate: true
    }
  },
  data() {
    return {
      currentPath: '/',
      menus: [
        {
          name: '商品(抖音+快手)',
          path: '/business/goods-manager'
        },
        {
          name: '批量导入',
          path: '/business/goods-import'
        },
        {
          name: '订单列表',
          path: '/business/order-list'
        },
        {
          name: '积分中心',
          path: '/business/integral-center'
        },
        {
          name: '积分充值',
          path: '/business/recharge'
        },
        {
          name: '放单规则',
          path: '/business/arrow-order-rule'
        },
        {
          name: '扣费规则',
          path: '/business/charging-rule'
        }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.setting-cnt {
  display: flex;
}
.menus {
  flex-shrink: 0;
  .menu {
    width: 15vw;
    height: 41px;
    background: #FFFFFF;
    box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .icon {
      width: 18px;
      height: 18px;
      object-fit: contain;
      margin-right: 8px;
    }

    .name {
      font-weight: 500;
      color: #333333;
      font-size: 15px;
    }

  }


  .menu:hover {
    box-shadow: 2px 2px 28px 2px rgba(217, 217, 217, 0.59);
  }

  .menu-selected {
    border: 1px solid #AE5CFF;
    .name {
      color: #8D12F8;
    }
  }
}

.setting-body {
  flex-grow: 1;
  margin-left: 15px;
  margin-right: 15px;
}
</style>
